import Icon from 'veui/components/Icon'
import { IconAnticlockwise } from 'dls-icons-vue'

Icon.register('anticlockwise', IconAnticlockwise)
